import { render, staticRenderFns } from "./CustomRoamingPoint.vue.html?vue&type=template&id=3564abf1&lang=html&external"
import script from "./CustomRoamingPoint.vue.js?vue&type=script&lang=js&external"
export * from "./CustomRoamingPoint.vue.js?vue&type=script&lang=js&external"
import style0 from "./CustomRoamingPoint.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports